var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletconnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BFD8817A-D7F2-4F1B-A8A3-C5E0F22BC3B0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NL-Home---Unlock-wallet",
    transform: "translate(-670.000000, -228.000000)",
    fill: "#3B99FC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "block-2",
    transform: "translate(360.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(60.000000, 173.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy",
    transform: "translate(220.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph/icon/metamask",
    transform: "translate(30.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet-connect.37f2bc6e",
    transform: "translate(0.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4795143,12.0854204 C36.7832557,-3.8773017 63.2168433,-3.8773017 79.520584,12.0854204 L81.4827657,14.0065595 C82.2979527,14.8046956 82.2979527,16.0987299 81.4827657,16.8968663 L74.770534,23.4687007 C74.3629403,23.867769 73.7021007,23.867769 73.294507,23.4687007 L70.5943123,20.8249847 C59.220415,9.6889908 40.7796837,9.6889908 29.4057861,20.8249847 L26.5141007,23.6561864 C26.1065068,24.0552544 25.445667,24.0552544 25.0380738,23.6561864 L18.3258422,17.084352 C17.5106551,16.2862156 17.5106551,14.9921813 18.3258422,14.1940452 L20.4795143,12.0854204 Z M93.402113,25.6766687 L99.376012,31.5256344 C100.191195,32.3237667 100.1912,33.6177933 99.3760223,34.415931 L72.4392987,60.7896423 C71.6241173,61.5877843 70.302438,61.5877933 69.4872453,60.789663 C69.487242,60.7896597 69.487238,60.7896557 69.4872347,60.7896523 L50.369187,42.0714617 C50.1653903,41.8719277 49.8349703,41.8719277 49.6311737,42.0714617 C49.6311723,42.071463 49.6311713,42.0714643 49.63117,42.0714653 L30.5135296,60.7896423 C29.6983507,61.5877863 28.3766711,61.5877997 27.5614759,60.7896713 C27.5614711,60.7896667 27.561466,60.789662 27.5614609,60.7896567 L0.623987757,34.415595 C-0.19119898,33.617459 -0.19119898,32.3234245 0.623987757,31.5252884 L6.59789763,25.6763327 C7.41308437,24.8781966 8.73476393,24.8781966 9.54995103,25.6763327 L28.6682769,44.394785 C28.8720738,44.594319 29.2024932,44.594319 29.4062901,44.394785 C29.4062932,44.394782 29.4062959,44.3947793 29.406299,44.394777 L48.5236667,25.6763327 C49.338835,24.8781782 50.6605147,24.8781483 51.4757203,25.676266 C51.4757317,25.6762772 51.475743,25.6762884 51.475754,25.6762997 L70.5940547,44.394777 C70.7978513,44.5943107 71.1282713,44.5943107 71.332068,44.394777 L90.4500597,25.6766687 C91.2652467,24.8785323 92.586926,24.8785323 93.402113,25.6766687 Z",
    id: "WalletConnect"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/walletconnect.6cd4621a.svg";
export { ForwardRef as ReactComponent };